import React from 'react';
import "../../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Vice-Chancellor</h1>
                <p>Home &gt; About-us &gt; Vice-Chancellor</p>
            </div>
        </div>
    )
}

export default Hero;